<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  <div class='global-panel' v-loading.body="loading.main">
    <div class="global-header">
      <div class="global-title">课程选择</div>
      <div class='global-tbar'>
        <el-input size="small" v-model="condition.courseTaskName" placeholder="标题"></el-input>
        <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <div class="global-paging" v-show="paging.allNum > paging.everySize" >
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-for='data in dataList' style="padding-bottom: 10px">
          <el-card class="box-card">
            <template #header>
              <div class="card-header">
                <span style="font-size:14px">{{data.taskName}}</span>
                <el-button v-if="data.taskStatus==='进行中'" class="button" size="small" type="success" @click="chooseCourseTask(data)">选 择 课 程</el-button>
                <el-button v-if="data.taskStatus!=='进行中'" class="button" size="small" plain type="info" @click="chooseCourseTask(data)">查 看 课 程</el-button>
              </div>
            </template>
            <div style="padding-bottom: 10px" class="course-desc">
            <span>状态：</span>
            <span v-if="data.taskStatus==='未开始'" style ="color:blue">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='进行中'" style ="color:red">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='已结束'" style ="color:grey">{{data.taskStatus}}</span>
            <span v-if="data.taskStatus==='已冻结'" style ="color:grey">{{data.taskStatus}}</span>
            </div>
            <div style="padding-bottom: 30px" class="course-desc">
              <span>选课要求：</span>
              {{data.taskDesc}}
            </div>
            <div style="padding-bottom: 15px">
              <span style="color:orange">已选课程：</span>
              {{data.selectedCourse}}
            </div>
            <div><span style="color:green">开始时间：</span>
              <el-date-picker size="small" readonly
              v-model="data.startTime"
              type="datetime"/>
            </div>
            <div style="padding-bottom: 10px"><span style="color:red">结束时间：</span>
              <el-date-picker size="small" readonly
                v-model="data.endTime"
                type="datetime"/>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 分页  -->
      <div v-show="paging.allNum > paging.everySize" class="global-paging">
        <hr/>
        <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
      </div>
    </div>
  </div>
  <el-dialog :visible.sync="visible.choose" width="70%" v-loading="loading.choose" fullscreen :close-on-click-modal="false" :close-on-press-escape="false" @close = "findByCondition()">
    <el-row>
      <div class="global-title"><span>{{currentRecord.taskName}}(</span>
        <span v-if="currentRecord.taskStatus==='未开始'" style ="color:blue">{{currentRecord.taskStatus}}</span>
        <span v-if="currentRecord.taskStatus==='进行中'" style ="color:red">{{currentRecord.taskStatus}}</span>
        <span v-if="currentRecord.taskStatus==='已结束'" style ="color:grey">{{currentRecord.taskStatus}}</span>
        <span v-if="currentRecord.taskStatus==='已冻结'" style ="color:grey">{{currentRecord.taskStatus}}</span>
        <span>)</span>
      </div>
      <div class='global-tbar'>
        <el-button size="small" type="primary"  @click="chooseCourseTask(currentRecord)" :disabled="isDisabled">刷新</el-button>
      </div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 30px">
        <span>欢迎，{{clazz.clazzName}} | {{student.studentName}}</span>
      </div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 30px">
        <span>选课要求：</span>
        {{currentRecord.taskDesc}}
      </div>
    </el-row>
    <el-row>
      <div style="padding-bottom: 15px"><span style="color:green">开始时间：</span>
        <el-date-picker size="small" readonly
                        v-model="currentRecord.startTime"
                        type="datetime"/>
      </div>
      <div style="padding-bottom: 20px"><span style="color:red">结束时间：</span>
        <el-date-picker size="small" readonly
                        v-model="currentRecord.endTime"
                        type="datetime"/>
      </div>
      <div style="padding-bottom: 30px">
        <span style="color:orange">已选课程：</span>
        {{currentRecord.selectedCourse}}
      </div>
    </el-row>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-for='course in courseList' style="padding-bottom: 10px">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              <span style="font-size:14px">{{course.courseName}}<span v-if="course.selected" style="color: red;font-weight: bold"> (已选中)</span></span>
              <el-button v-if="$baize.isEmpty(currentRecord.selectedCourse) && currentRecord.taskStatus==='进行中'" class="button" size="small" type="success" plain @click="selectCourse(course)">选 择 课 程</el-button>
              <el-button v-if="course.selected && !course.freeze" class="button" size="small" type="danger" @click="cancelCourse(course)">取 消 选 课</el-button>
            </div>
          </template>
          <div style="padding-bottom: 15px;" class="course-detial-desc">
            <span>课程简介：</span>
            <div style="height:120px;overflow-y:auto">
              {{course.courseDesc}}
            </div>

          </div>
          <div style="padding-bottom: 5px">
            <span style="color:green">任课教师：</span> {{course.teacher}}
          </div>
          <div style="padding-bottom: 5px">
            <span style="color:orange">人数：</span> {{course.personNum}}/ <span style="color:red">{{course.upperLimit}}</span>
            <span style="color:orange;padding-left: 5px">学时：</span> {{course.clazzHour}}
            <span style="color:orange">学分：</span> {{course.credit}}
          </div>
          <div style="padding-bottom: 5px">
            <span style="color:orange">上课地点：</span> {{course.place}}
          </div>
          <div style="padding-bottom: 5px">
            <span style="color:orange">上课时间：</span> {{course.courseTime}}
            <span style="color:orange">节次：</span> {{course.startSection}} - {{course.endSection}}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
    <el-button @click="visible.choose = false" type="danger" size="small" >关 闭</el-button>
  </span>
  </el-dialog>
</div>

</template>

<script>

export default {
  name: 'CourseChoose',
  data () {
    return {
      // 遮罩
      loading: {main: false, choose: false},
      // 可见
      visible: {choose: false},
      // 刷新按钮控制
      isDisabled: false,
      clickTimeout: null,
   	  // 检索条件
      condition: {courseTaskName:null},
      // 数据
      dataList: [],
      // 课程列表
      courseList: [],
      // 当前记录
      currentRecord: {},
      // 学生
      student: {},
      // 班级
      clazz: {},
   	  // 分页
      paging: {currPage: 1, everySize: 10, allNum: 0}
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.findByCondition();
  },

  methods: {
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/courseChoose/findByCondition', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.dataList = response.body.dataList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    chooseCourseTask: function (record) {
      var vm = this;
      if (this.isDisabled) {
        return; // 如果按钮已禁用，则不执行任何操作
      }

      this.isDisabled = true; // 禁用按钮
      this.clickTimeout = setTimeout(() => {
        this.isDisabled = false; // 2秒后重新启用按钮
      }, 2000);
      vm.currentRecord = record;
      vm.visible.choose = true;
      vm.loading.choose = true;
      vm.$http.get('rest/courseChoose/findCourseDetail', {params: {"taskId":vm.currentRecord.id}}).then(response => {
        vm.loading.choose = false;
        vm.courseList = response.body.courseList;
        vm.currentRecord = response.body.task;
        vm.student = response.body.student;
        vm.clazz = response.body.clazz;
      }, response => {
        // 关闭遮罩
        vm.loading.choose = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    selectCourse(course){
      var vm = this;
      vm.$confirm('确定要选择【' + course.courseName + '】吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.choose = true;
        // 请求后台
        vm.$http.post('rest/courseChoose/selectCourse', {"taskId":course.taskId,"courseId":course.id}).then(function (response) {
          // 关闭遮罩
          vm.loading.choose = false;
          vm.chooseCourseTask(vm.currentRecord)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.choose = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消操作'});
      });
    },
    cancelCourse(course){
      var vm = this;
      vm.$confirm('确定要取消【' + course.courseName + '】吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.choose = true;
        // 请求后台
        vm.$http.post('rest/courseChoose/cancelCourse', {"taskId":course.taskId,"courseId":course.id}).then(function (response) {
          // 关闭遮罩
          vm.loading.choose = false;
          vm.chooseCourseTask(vm.currentRecord)
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '操作成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.choose = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '操作失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消操作'});
      });
    }
  }
}
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
  }
  .course-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 2em;
    max-height: 2em;
  }
  .course-detail-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 3em;
    max-height: 3em;
  }
</style>



// WEBPACK FOOTER //
// src/app/CourseChoose.vue